import React from 'react';
import { footerColumns } from '../data/company';
export function SiteFooter() {
  return <footer className="pb-[110px] pt-11 text-sm text-muted" data-id="element-130" data-mp="3r7pvtsx9m72x">
      <div className="mx-auto max-w-[1080px] px-[22px]" data-id="element-131" data-mp="3racbkfub7sw8">
        <div className="mb-7 grid grid-cols-1 gap-[26px] sm:grid-cols-2 lg:grid-cols-4" data-id="element-132" data-mp="3mghm0vs0wjp8">
          {footerColumns.map(col => <div key={col.title} data-id="element-133" data-mp="3hi6e4qlagj9n">
              <p className="mb-2.5 text-xs font-bold uppercase tracking-[0.08em] text-fg" data-id="element-134" data-mp="3dgl4de41wl3o">{col.title}</p>
              <ul className="space-y-1 leading-relaxed" data-id="element-135" data-mp="38h8h4s99pc0k">
                {col.lines.map(line => <li key={line.text} data-id="element-136" data-mp="33i5c37taf5sl">
                    {line.href ? <a href={line.href} className="text-muted transition-colors duration-150 hover:text-fg" {...line.href.startsWith('http') ? {
                target: '_blank',
                rel: 'noopener noreferrer'
              } : {}} data-id="element-137" data-mp="2yjlnt0r81hx2">
                        {line.text}
                      </a> : line.text}
                  </li>)}
              </ul>
            </div>)}
        </div>
        <div className="border-t border-line pt-[22px] text-[13px] leading-[1.8]" data-id="element-138" data-mp="vtqwxv50s8d6">
          <p data-id="element-139" data-mp="10r8vqspbp77g">© 2026 Massive Faith LLC. Todos los derechos reservados.</p>
          <p data-id="element-140" data-mp="1ohcyyyyln4xx">Todos nuestros productos son digitales. No vendemos productos físicos. No operamos suscripciones ni cobros recurrentes.</p>
          <p data-id="element-141" data-mp="1tgpndo54ck2m">
            Los cargos figuran en tu extracto bancario como <strong className="font-bold text-fg" data-id="element-142" data-mp="1erjo606a6tuq">MASSIVE FAITH LLC</strong>.
          </p>
        </div>
      </div>
    </footer>;
}